import React from "react";

export default function LoginPreview({ colors, images, platformName, phrase, theme }) {
  const t = colors?.[theme] || colors?.light_theme || {};

  return (
    <div className="card shadow w-100 rounded" style={{ background: t.bgPrimary || "#fff", minHeight: 360, fontFamily: "Inter, sans-serif" }}>
      <div className="row g-0" style={{ minHeight: 360 }}>
        {/* Left - outdoor image */}
        <div className="col d-none d-sm-flex" style={{ background: t.bgTertiary || "#E6EDF5", minWidth: 0 }}>
          {images?.homeScreenImage ? (
            <img
              src={images.homeScreenImage}
              alt="outdoor"
              className="w-100 h-100"
              style={{ objectFit: 'cover', minHeight: 360 }}
            />
          ) : (
            <div className="w-100 h-100 d-flex flex-column align-items-center justify-content-center" style={{ background: `linear-gradient(135deg, ${t.themePrimary || "#1F3A5F"}, ${t.themeSecondary || "#162B45"})` }}>
              <div style={{ fontSize: '2.5rem', fontWeight: 900, color: 'rgba(255,255,255,0.2)' }}>OF</div>
              <div className="text-white-50 small text-center px-3">{phrase || "Ajudando sua empresa crescer"}</div>
            </div>
          )}
          <div className="position-absolute bottom-0 start-0 end-0 p-3" style={{ background: "linear-gradient(to top, rgba(0,0,0,0.6), transparent)" }}>
            <p className="text-white small mb-0">{phrase || "Ajudando sua empresa crescer"}</p>
          </div>
        </div>

        {/* Right - login form */}
        <div className="col-12 col-sm-7 d-flex flex-column justify-content-center px-4 py-4" style={{ background: t.bgCard || "#fff", minWidth: 220, flex: "0 0 55%" }}>
          {/* Logo */}
          <div className="d-flex justify-content-center mb-2">
            {images?.companyLogo ? (
              <img src={images.companyLogo} alt="logo" className="" style={{ height: 40, objectFit: 'contain' }} />
            ) : (
              <div className="h-10 px-3 rounded d-flex align-items-center justify-content-center fw-bold small" style={{ background: t.themePrimary || "#1F3A5F", color: "#fff", height: 40 }}>
                {platformName || "Plataforma"}
              </div>
            )}
          </div>

          <div className="mb-2">
            <p className="small fw-semibold mb-1" style={{ color: t.textPrimary || "#1F3A5F" }}>Usuário</p>
            <div className="rounded px-3 py-2 small border" style={{ background: t.bgSecondary || "#F4F7FB", borderColor: t.borderPrimary || "#D6DEE8", color: t.textMuted || "#A5B1C2" }}>
              seu@email.com
            </div>
          </div>

          <div className="mb-2">
            <p className="small fw-semibold mb-1" style={{ color: t.textPrimary || "#1F3A5F" }}>Senha</p>
            <div className="rounded px-3 py-2 small border" style={{ background: t.bgSecondary || "#F4F7FB", borderColor: t.borderFocus || "#FF7A1A", color: t.textMuted || "#A5B1C2" }}>
              ••••••••
            </div>
          </div>

          <button className="btn w-100 fw-bold small" style={{ background: t.buttons?.bgBtnPrimary || t.themePrimary || "#1F3A5F", color: t.buttons?.textPrimary || "#fff", borderColor: "transparent" }}>
            Entrar
          </button>

          <p className="text-center small mt-2" style={{ color: t.textMuted || "#A5B1C2" }}>Esqueci minha senha</p>
        </div>
      </div>
    </div>
  );
}